import button from './button';
import segmentGroup from './segmentGroup';

const recipeConfigs = [button, segmentGroup];
export default recipeConfigs;
